import PractitionersList from './PractitionersList';

export default PractitionersList;
